export default __webpack_public_path__ + "static/media/36I-114297_-20843_0.7a58e03e.jpg";